import Alpine from "alpinejs";

/**
 * conf is merged from global appConfig and pageConfig variables.
 */
Alpine.store("config", { ...window.appConfig, ...window.pageConfig });
